import React from 'react';
import useInView from './useInView';
import useMotionPrefs from './useMotionPrefs';

/* ==================================================================
   Stagger
   ------------------------------------------------------------------
   Wraps a list so its children arrive in sequence off ONE observer
   rather than one per child. The per-child index comes from a
   :nth-child rule in motion.css, so this works for component children
   as well as plain elements and React re-renders nothing while the
   sequence plays.

   `step` sets the gap between children. Past the twelfth child the
   index stops advancing, so a long list never ends with a card
   waiting three seconds to appear.
   ================================================================== */

export default function Stagger({
  as: Tag = 'div',
  step = 45,
  threshold,
  className = '',
  style,
  children,
  ...rest
}) {
  const { reduced } = useMotionPrefs();
  const [ref, inView] = useInView({ threshold, skip: reduced });

  return (
    <Tag
      ref={ref}
      className={`ui-stagger ${className}`.trim()}
      data-in={inView ? 'true' : 'false'}
      style={{ ...style, '--ui-step': `${step}ms` }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
